const state = {
  userName: ''
}

const mutations = {
  UPDATE_USERNAME(state, userName) {
    state.userName = userName
  }
}

const actions = {
  setUserNameAct({ commit }, userName) {
    commit('UPDATE_USERNAME', userName)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
